(function(){
    const DROPDOWN_CLASS = "dropdown"
    const dropdowns = document.querySelectorAll(`.${DROPDOWN_CLASS}`)
    dropdowns.forEach(async (dd) => {
        const {Dropdown} = await import(/* webpackChunkName: "dropdown" */'./Dropdown')
        new Dropdown(dd).init()
    })
})()
